const font = {
  fontFamily:
    "'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', 'ヒラギノ角ゴ Pro W3','Hiragino Kaku Gothic Pro', Osaka, sans-serif, 'Lucida Grande', 'Lucida Sans Unicode', Helvetica,Arial, Verdana",
  fontSize: '12px',
};

const nonOverflowText = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

const globalAreaButtonFont = {
  ...font,
  color: 'white',
  fontWeight: 'bold',
};

export { font, globalAreaButtonFont, nonOverflowText };
